import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { LocationS } from "../location/location";

@JsonConverter
export class ClientCounter implements JsonCustomConvert<Client>{
    serialize() { }
    deserialize(data: any): Client {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeObject(data, Client);
    }
}

@JsonConverter
export class ClientArrayCounter implements JsonCustomConvert<Array<Client>>{
    serialize() { }
    deserialize(data: any): Array<Client> {
        const jsonConvert: JsonConvert = new JsonConvert();
        return jsonConvert.deserializeArray(data, Client);
    }
}

@JsonObject("Client")
export class Client{
    @JsonProperty("id", String, true)
    id: string = "";
    @JsonProperty("verified", Boolean, true)
    verified: boolean = false;
    @JsonProperty("first_name", String, true)
    first_name: string = "";
    @JsonProperty("last_name", String, true)
    last_name: string = "";
    @JsonProperty("email", String, true)
    email: string = "";
    @JsonProperty("phone_number", String, true)
    phone_number: string = "";
    @JsonProperty("last_update", Number, true)
    last_update: number = 0;
    @JsonProperty("registered_at", Number, true)
    registered_at: number = 0;
    @JsonProperty("marketing_consent", Boolean, true)
    marketing_consent: boolean = false;
    @JsonProperty("profile_consents", Boolean, true)
    profile_consents: boolean = false;
    @JsonProperty("strategy", String, true)
    strategy: string = "";
    @JsonProperty("location_id", String, true)
    location_id: string = "";

    _location: string | undefined = "";
    setLocation(locations: Array<LocationS>) {
		this._location = locations.find(l => l.id === this.location_id) ? locations.find(l => l.id === this.location_id)?.name : "";
	}
}

@JsonObject("ClientsListCount")
export class ClientsListCount {
    @JsonProperty("count", Number, true)
    count: number = 0;
    @JsonProperty("data", ClientArrayCounter, true)
    data: Array<Client> = new Array<Client>();

    setLocations(locations: Array<LocationS>) {
		this.data.forEach(d => {
			d.setLocation(locations);
		});
	}
}

@JsonObject("ClientsListData")
export class ClientsListData extends BaseResponse{
    @JsonProperty("data", ClientsListCount, true)
    data: ClientsListCount = new ClientsListCount;

    setLocations(locations: Array<LocationS>) {
		this.data.data.forEach(d => {
			d.setLocation(locations);
		});
	}
}

@JsonObject("ClientsData")
export class ClientsData extends BaseResponse{
    @JsonProperty("data", ClientCounter, true)
    data: Client = new Client;
}